(function() {
  function positionTooltip(button) {
    const tooltip = button.querySelector(".cart-item__disclosure-tooltip");
    if (!tooltip) return;
    tooltip.style.setProperty("--cart-disclosure-tooltip-shift", "0px");
    const rect = tooltip.getBoundingClientRect(), viewportWidth = document.documentElement.clientWidth;
    let shift = 0;
    rect.right > viewportWidth - 16 ? shift = viewportWidth - 16 - rect.right : rect.left < 16 && (shift = 16 - rect.left), tooltip.style.setProperty("--cart-disclosure-tooltip-shift", `${Math.round(shift)}px`);
  }
  function onPointerOver(event) {
    var _a, _b;
    const button = (_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, ".cart-item__disclosure");
    !button || button.dataset.tooltipPositioned === "true" || (button.dataset.tooltipPositioned = "true", positionTooltip(button));
  }
  function onPointerOut(event) {
    var _a, _b;
    const button = (_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, ".cart-item__disclosure");
    button && !button.contains(event.relatedTarget) && delete button.dataset.tooltipPositioned;
  }
  document.addEventListener("pointerover", onPointerOver), document.addEventListener("pointerout", onPointerOut);
})();
